/*
 * Copyright (c) 2024 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 17/1/2024
 */

import { Box, Button, Container, Paper, Toolbar, Typography } from "@mui/material"
import { useState } from "react";
import { useDispatch } from "react-redux"
import SearchBar from "../Components/Shared/SearchBar";
import PrivilegeDialog from "../Components/Privilege/PrivilegeDialog";
import PrivilegeList from "../Components/Privilege/PrivilegeList";
import { useGetAllPrivsQuery } from "../Store/Services/PrivilegeService";
import { closePrivModal, openAddPrivModal } from "../Store/Slices/privSlice";
import styles from "./Management.module.css";

const PrivilegeManagement = () => {

     const dispatch = useDispatch();
     const [searchData, setSearchData] = useState([])
     const { data, isSuccess, isLoading } = useGetAllPrivsQuery();

     const handleClose = () => {
        dispatch(closePrivModal());
    }

    const roles = sessionStorage.getItem("roles");

    return (
        roles?.split(",").includes("PRIV_ES_DISPLAY_PRIVILEGES") ? (
        <Paper elevation={3} className={styles.pageContainer} style={{backgroundImage: `url(${process.env.REACT_APP_IMAGE_URL}E_SERVICE/thumbnail_Management.png)`}}>
            <Box>
                <Toolbar className={styles.subNavBar}>
                    <Typography className={styles.topic}>Privilege Management</Typography>
                    {roles?.split(",").includes("PRIV_ES_ADD_PRIVILEGE")  ? (<Button variant="contained" color="primary" className={styles.buttonItem} onClick={() => dispatch(openAddPrivModal())}>Add Privilege</Button>) : null}
                </Toolbar>
            </Box>
            <Container id={styles.container}>
                <SearchBar
                    data={isSuccess || isLoading ? data : []}
                    setSearchData={setSearchData}
                    text="Search Privileges"
                    search="priv"
                />
            </Container>

            <Container>
               {isSuccess && <PrivilegeList data={Array.isArray(searchData) && searchData.length > 0 ? searchData : data}/>}
            </Container>

            <PrivilegeDialog handleClose={handleClose} />
        </Paper> ) : null
    )
}

export default PrivilegeManagement